<h3>Preview</h3>
<p>Preview your menu by scanning the qr code below.</p>
<div #QRCanvas></div>
